import React from 'react'
import { Link } from 'gatsby'

const SubItems = ({ subitems, index }) => {
  return (
    <ul className='mega-subitems'>
      {subitems.map((item, index) => {
        return (
          <li key={index} className='mega-subitem'>
            <Link to={item.uri}>
              <span>{item.name}</span>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default SubItems
